import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileExcel, faFileWord } from "@fortawesome/free-solid-svg-icons";
import "./AcuerdosDetail.css";

export const AcuerdosPdfButton = ({ url, label, type = "pdf" }) => {
  if (!url) return null;
  const isExcel = type === "excel";
  const isWord = type === "word";

  let icon = faFilePdf;
  let modifierClass = "";

  if (isExcel) {
    icon = faFileExcel;
    modifierClass = "is-excel";
  } else if (isWord) {
    icon = faFileWord;
    modifierClass = "is-word";
  }

  const fileTypeLabel = isExcel ? "Excel" : isWord ? "Word" : "PDF";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`acuerdos-pdf-btn ${modifierClass}`.trim()}
      aria-label={label ? `Abrir ${fileTypeLabel}: ${label}` : `Abrir documento ${fileTypeLabel}`}
      title={label ? `Abrir ${fileTypeLabel}: ${label}` : `Abrir documento ${fileTypeLabel}`}
    >
      <FontAwesomeIcon icon={icon} />
    </a>
  );
};

AcuerdosPdfButton.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
};

export const AcuerdosDetailRow = ({
  title,
  url,
  type = "pdf",
  isMain = false,
  isSub = false,
}) => {
  return (
    <div
      className={`acuerdos-detail-row ${isMain ? "is-main" : ""} ${
        isSub ? "is-sub" : ""
      }`.trim()}
    >
      <AcuerdosPdfButton url={url} label={title} type={type} />
      <div
        className={`acuerdos-detail-text ${
          !isMain && !isSub ? "is-anexo-title" : ""
        } ${isSub ? "is-sub" : ""}`.trim()}
      >
        {isSub && <span className="acuerdos-detail-sub-indicator">└</span>}
        {title}
      </div>
    </div>
  );
};

AcuerdosDetailRow.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  type: PropTypes.string,
  isMain: PropTypes.bool,
  isSub: PropTypes.bool,
};

export const AcuerdosDetailSection = ({ title, children }) => {
  return (
    <div className="acuerdos-detail-section">
      {title && <span className="acuerdos-detail-title TabRegis">{title}</span>}
      <div className="acuerdos-detail-list">{children}</div>
    </div>
  );
};

AcuerdosDetailSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export const AcuerdosDetailContainer = ({ children }) => {
  return <div className="acuerdos-detail-container">{children}</div>;
};

AcuerdosDetailContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const AcuerdosDetail = {
  AcuerdosDetailContainer,
  AcuerdosDetailSection,
  AcuerdosDetailRow,
  AcuerdosPdfButton,
};

export default AcuerdosDetail;
